import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { CompareFunction, Theme } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormSelectCompareFormatComponent from 'webapp/components/form/select-compare-format';
import FormSelectCompareFunctionComponent from 'webapp/components/form/select-compare-function';
import FormSelectCompareTypeComponent from 'webapp/components/form/select-compare-type';

import type DataSelect from 'webapp/models-custom/data-select';
import type DsCompare from 'webapp/models-custom/ds-compare';

interface Args {
	model: DsCompare;
	dataSelect: DataSelect;
	remove: (compare: DsCompare) => void;
	onChange: (oldCompare: DsCompare, newCompare: DsCompare) => void;
	showFormatAndFunction?: boolean;
	hideRemove?: boolean;
	isDisabled?: boolean;
	theme?: Theme | string;
}

export default class BlockSettingsMetricCompareComponent extends Component<Args> {
	get showFormatAndFunction() {
		return !!this.args.showFormatAndFunction && !this.args.model.isNone;
	}

	@action
	removeCompare(): void {
		this.args.remove(this.args.model);
	}

	@action
	changeCompare(newCompare: DsCompare): void {
		this.args.onChange(this.args.model, newCompare);
	}

	@action
	changeFunction(compareFunction: CompareFunction): void {
		const newCompare = this.args.model.createCopy();
		newCompare.function = compareFunction;
		this.changeCompare(newCompare);
	}

	@action
	changeFormat(format: string): void {
		const newCompare = this.args.model.createCopy();
		newCompare.format = format;
		this.changeCompare(newCompare);
	}
	<template>
		<div class="row bs__metric__compare">
			<FormSelectCompareTypeComponent
				@model={{@model}}
				@dataSelect={{@dataSelect}}
				@onChange={{this.changeCompare}}
				@isDisabled={{@isDisabled}}
				@theme={{@theme}}
			/>
			{{#if this.showFormatAndFunction}}
				<FormSelectCompareFunctionComponent
					@model={{@model}}
					@onChange={{this.changeFunction}}
					@isDisabled={{@isDisabled}}
				/>
				<FormSelectCompareFormatComponent
					@model={{@model}}
					@onChange={{this.changeFormat}}
					@isDisabled={{@isDisabled}}
				/>
			{{/if}}
			{{#unless @hideRemove}}
				<a class="action-remove" {{on "click" this.removeCompare}}>
					<CommonUiIconComponent @name="Close" @size="sm" />
				</a>
			{{/unless}}
		</div>
	</template>
}
